import React from 'react';

import './index.css';

import { LexicalComposer } from '@lexical/react/LexicalComposer';
import { $generateNodesFromDOM } from '@lexical/html';
import { $insertNodes } from 'lexical';

import theme from './themes';
import Editor from './Editor';
import { SharedHistoryContext } from './context/SharedHistoryContext';
import EditorNodes from './nodes/EditorNodes';
import { TableContext } from './plugins/TablePlugin';
import SharedAutocompleteContext from './context/SharedAutocompleteContext';

const EditorWrapper = ({ htmlString, editorRef }) => {
  const initialConfig = {
    editorState: (editor) => {
      if (htmlString) {
        editor.update(() => {
          const parser = new DOMParser();
          const dom = parser.parseFromString(htmlString, 'text/html');
          const nodes = $generateNodesFromDOM(editor, dom);
          $insertNodes(nodes);
        });
      }
    },
    namespace: 'Editor',
    onError: (error) => {
      throw error;
    },
    theme: theme,
    nodes: [...EditorNodes],
  };

  return (
    <LexicalComposer initialConfig={initialConfig}>
      <SharedHistoryContext>
        <TableContext>
          <SharedAutocompleteContext>
            <div className="editor-shell">
              <Editor htmlString={htmlString} editorRef={editorRef} />
            </div>
          </SharedAutocompleteContext>
        </TableContext>
      </SharedHistoryContext>
    </LexicalComposer>
  );
};

export default EditorWrapper;
